import React from 'react'
import { View, ViewStyle, StyleSheet } from 'react-native'
import { Text } from 'react-native-paper'
import Color from 'color'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

export const Status = ({
  label,
  textColor,
  style,
  info,
}: {
  label: string
  textColor: string
  style?: ViewStyle
  info?: string
}) => {
  return (
    <View style={{ flexDirection: 'column' }}>
      <View
        style={{
          marginVertical: 6,
          height: 22,
          borderRadius: 5,
          backgroundColor: Color(textColor).alpha(0.1).rgb().string(),
          justifyContent: 'center',
          alignSelf: 'flex-end',
          ...style,
        }}
      >
        <Text style={composeStyle(styles.label, { color: textColor })}>
          {label}
        </Text>
      </View>
      {info && <Text style={styles.info}>{info}</Text>}
    </View>
  )
}

const styles = StyleSheet.create({
  info: {
    fontWeight: '500',
    fontSize: 10,
    marginTop: 2,
    color: '#DA515E',
  },
  label: {
    fontWeight: '500',
    fontSize: 11,
    paddingHorizontal: 10,
  },
})
